export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESET = "AUTH_RESET";
export const AUTH_REGISTER = "AUTH_REGISTER";
export const AUTH_REQUEST_REFRESH_TOKEN = "AUTH_REQUEST_REFRESH_TOKEN";
export const AUTH_REQUEST_IFRAME = "AUTH_REQUEST_IFRAME";
